module.exports = "/assets/data/68e82197f49efe6fcf7de1922f113e2d-HR7.data.json";